import { animate, style, transition, trigger } from '@angular/animations';

export function fadeInAnimation() {
  return [
    trigger('fadeIn', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate('0.4s ease', style({ opacity: '*' })),
      ]),
      transition('* => void', [
        style({ opacity: '*' }),
        animate('0.4s ease', style({ opacity: 0 })),
      ]),
    ]),
  ];
}
